import { URL_API_AUTH } from 'src/config';
import baseActions from '../baseActions';

const path = 'master-documents';
export const actionType = (action) => {
  return {
    request: `${action}_${path}_request`.toUpperCase(),
    success: `${action}_${path}_success`.toUpperCase(),
    error: `${action}_${path}_error`.toUpperCase(),
  };
};

const document = {
  ...baseActions(URL_API_AUTH, path, actionType),
};
export default document;
